module.exports = __webpack_public_path__ + "static/media/FabLogo.bc9ec240.svg";